/**
 * Offline-first gate for Supabase network calls.
 * After DNS / fetch failures, pause further requests (cooldown) to cut console noise.
 *
 * Auth credential failures (HTTP 400) must NOT freeze the gate — they prove the network works.
 */

const COOLDOWN_MS = 60 * 1000;

let lastFailureAt = 0;

export function markSupabaseUnreachable() {
  lastFailureAt = Date.now();
}

export function markSupabaseReachable() {
  lastFailureAt = 0;
}

export function isSupabaseNetworkPaused() {
  return lastFailureAt > 0 && Date.now() - lastFailureAt < COOLDOWN_MS;
}

export function shouldAllowSupabaseNetwork() {
  return !isSupabaseNetworkPaused();
}

/** Admin dashboard / auth recovery — always attempt network. */
export function forceAllowSupabaseNetwork() {
  markSupabaseReachable();
}

if (typeof window !== 'undefined') {
  window.addEventListener('online', () => {
    markSupabaseReachable();
  });
}
